












































import eventBus from "@/utils/bus";
import { calendar as calenderFormate } from "@/utils/calendar";
import { Prop, Vue, Component, Watch } from "vue-property-decorator";
@Component
export default class extends Vue {
  @Prop() originEvents!: any[];
  @Watch("originEvents", { immediate: false, deep: false })
  originEventsChange(n: any[]) {
    const res: any[] = [];
    let row: any[] = [];
    let current_mark = false;
    const today = new Date();
    n.map((item: any, index: number) => {
      const _date = item.date.split("-");
      const _dateF: any = calenderFormate.solar2lunar(
        _date[0],
        _date[1],
        _date[2]
      );
      // 判断当天
      if (
        today.getFullYear() === Number(_date[0]) &&
        today.getMonth() + 1 === Number(_date[1]) &&
        today.getDate() === Number(_date[2])
      ) {
        item.today = true;
      }
      item.lunar = _dateF.IDayCn;
      item.lesson_list = item.lesson_list.slice(0, 2);
      if (Number(_date[2]) === 1) {
        current_mark = !current_mark;
      }
      item.is_current_month = current_mark;
      if (index === n.length - 1) {
        row.push(item);
        res.push(row);
      } else if (row.length === 7) {
        res.push(row);
        row = [item];
      } else {
        row.push(item);
      }
    });
    this.eventList = res;
  }
  eventList: any[] = [];
  scrollToLeft(v: number) {
    if (v === 1) {
      const ppp: any = this.$refs["month-time-view"];
      ppp.scrollLeft -= 960;
    }
    if (v === 2) {
      const ppp: any = this.$refs["month-time-view"];
      ppp.scrollLeft += 960;
    }
  }
  toDayView(date: string) {
    eventBus.$emit("schecule-switch-to-day-view", date);
  }
}
